import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 导入所有语言的翻译文件
import enTranslation from '../locales/locale/en.json';
import zhTranslation from '../locales/locale/zh_CN.json';

const resources = {
    en: {
        translation: enTranslation
    },
    zh: {
        translation: zhTranslation
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',

        // keySeparator: false, // 禁用键分隔符，如果你的key中包含点号 '.'

        interpolation: {
            escapeValue: false
        },

        debug: true
    });

export default i18n;